import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { RouteGuard } from '../../lib/route-guard.js';
import { useReorderPrefillState } from '../../modules/inventory/reorder-sheet/use-reorder-prefill-state.js';
import { PurchaseOrderCreateForm } from '../../modules/purchasing/purchase-order-create-form.js';

export const Route = createFileRoute('/purchase-orders/new')({
  component: NewPurchaseOrderPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewPurchaseOrderPage() {
  const [formGeneration, setFormGeneration] = useState(0);
  const { prefill, returnTo } = useReorderPrefillState('NEW_PO');
  return (
    <RouteGuard route="/purchase-orders/new">
      <div>
        <PurchaseOrderCreateForm
          key={formGeneration}
          reorderPrefill={formGeneration === 0 ? prefill : null}
          returnTo={returnTo}
          onCreateAnother={() => setFormGeneration((generation) => generation + 1)}
        />
      </div>
    </RouteGuard>
  );
}
